const A = "https://customer-assets-39nsmqrw.emergentagent.net/job_lakou-beats/artifacts";

export const IMAGES = {
    hero: `${A}/7c098a69900097b1_DSC_1752.webp`,
    hookah: `${A}/5d9fc64c883c1fef_DSC_1746.webp`,
    women: `${A}/c2f31ebe610993fa_DSC_1675.webp`,
    flag: `${A}/812ab061de307e6a_DSC_1651.webp`,
    squad: `${A}/c8ee7654ac5eb7ad_DSC_1641.webp`,
    lakouShirt: `${A}/7cff3694bee91838_DSC_1612.webp`,
    crew: `${A}/277a287f3d1959ed_DSC_1609.webp`,
    palm: `${A}/82944f8f6b3d41b9_3fc05f89-8cdf-4255-b8a4-aa94d14bed12.JPG`
};

export const GALLERY_PHOTOS = [
    { src: `${A}/9beac6708c374463_DSC_1773%202.webp`, caption: "String lights over the lakou", tag: "Nightlife" },
    { src: `${A}/ef69589cb91a7a9b_DSC_1722.webp`, caption: "Smoke signals, golden hour", tag: "Nightlife" },
    { src: `${A}/c16d64014c67b7e2_DSC_1719.webp`, caption: "The tribe showed out", tag: "Community" },
    { src: `${A}/982cccec4f4b4a0e_DSC_1713.webp`, caption: "The LAKOU booth — flags up by day", tag: "Culture" },
    { src: IMAGES.hero, caption: "Lakou Nights — flags up, lights low", tag: "Community" },
    { src: IMAGES.hookah, caption: "Midnight energy", tag: "Nightlife" },
    { src: IMAGES.women, caption: "Golden fits only", tag: "Fashion" },
    { src: IMAGES.flag, caption: "Ayiti in the building", tag: "Culture" },
    { src: IMAGES.squad, caption: "The tribe", tag: "Community" },
    { src: IMAGES.lakouShirt, caption: "LAKOU EST. 2025", tag: "Fashion" },
    { src: IMAGES.crew, caption: "Night shift", tag: "Nightlife" },
    { src: IMAGES.palm, caption: "Island posture", tag: "Culture" }
];

export const MARQUEE_ITEMS = [
    "AFRO HOUSE", "AMAPIANO", "RABÒDAY", "LÉOGÂNE", "DECEMBER 12", "LAKOU IS A FEELING", "AYITI"
];

export const EVENT_FAQ = [
    { q: "Where exactly is the event?", a: "Donpee Guest House — 7 Route de Mathieu, Léogâne. The experience starts at 7:30 PM; present your QR ticket at the entrance." },
    { q: "What time does it start?", a: "The experience starts at 7:30 PM sharp. Come early — the full night schedule will be announced on official Lakou channels." },
    { q: "How do I receive my ticket?", a: "After your payment is confirmed, your unique QR-code ticket appears on the confirmation page and is linked to your email. Show it at the entrance — our team scans and validates it instantly." },
    { q: "Can I get a refund?", a: "Please read our ticket refund policy in the footer before purchasing — in short: sales are final, but cancellations and reschedules are fully covered." },
    { q: "Is there a dress code?", a: "Come as you are — warm earth tones and Afro elegance are the vibe, never the rule." },
    { q: "What payment methods are accepted?", a: "Secure card payments at launch. MonCash, NatCash and other local providers are being integrated for Haiti." }
];

export const FAQS = {
    en: EVENT_FAQ,
    ht: [
        { q: "Kote evènman an fèt egzakteman?", a: "Donpee Guest House — 7 Route de Mathieu, Leyogàn. Eksperyans la kòmanse a 7:30 PM; montre tikè QR ou nan antre a." },
        { q: "A ki lè li kòmanse?", a: "Eksperyans la kòmanse a 7:30 PM. Vini bonè — n ap anonse pwogram konplè aswè a sou chanèl ofisyèl LAKOU yo." },
        { q: "Kijan mwen resevwa tikè mwen?", a: "Apre peman ou konfime, tikè QR ou a parèt sou paj konfirmasyon an epi li mare nan imèl ou. Montre l nan antre a — ekip nou skane l touswit." },
        { q: "Èske mwen ka jwenn ranbousman?", a: "Tanpri li politik ranbousman tikè nou an nan pye paj la anvan ou achte — an rezime: vant yo definitif, men si nou anile oswa ranvwaye evènman an, ou jwenn tout kòb ou." },
        { q: "Èske gen kòd abiyeman?", a: "Vini jan ou ye — ton tè cho ak elegans afriken se vibe la, pa yon règ." },
        { q: "Ki metòd peman nou aksepte?", a: "Kat bankè sekirize, MonCash ak NatCash. Lòt founisè lokal ap vini." }
    ],
    fr: [
        { q: "Où a lieu l'événement exactement ?", a: "Donpee Guest House — 7 Route de Mathieu, Léogâne. L'expérience commence à 19h30 ; présentez votre billet QR à l'entrée." },
        { q: "À quelle heure ça commence ?", a: "L'expérience commence à 19h30 précises. Venez tôt — le programme complet de la nuit sera annoncé sur les canaux officiels LAKOU." },
        { q: "Comment je reçois mon billet ?", a: "Une fois votre paiement confirmé, votre billet QR unique apparaît sur la page de confirmation et reste lié à votre email. Présentez-le à l'entrée — notre équipe le scanne instantanément." },
        { q: "Puis-je être remboursé ?", a: "Veuillez lire notre politique de remboursement en bas de page avant d'acheter — en résumé : ventes finales, mais annulations et reports sont intégralement remboursés." },
        { q: "Y a-t-il un dress code ?", a: "Venez comme vous êtes — les tons terre chauds et l'élégance afro sont l'ambiance, jamais une règle." },
        { q: "Quels moyens de paiement acceptez-vous ?", a: "Cartes bancaires sécurisées, MonCash et NatCash. D'autres options locales arrivent." }
    ]
};

export const CONTACT_CATEGORIES = [
    "General questions", "Ticket support", "Artist bookings", "Sponsorships",
    "Merchandise orders", "Press & media", "Partnerships", "Bring LAKOU to my city"
];

export const PARTNERSHIP_TYPES = [
    "Event sponsorship", "Beverage partnership", "Brand activation",
    "Merchandise collaboration", "Media partnership", "Hospitality partnership", "Long-term strategic partnership"
];
